"use client";
import * as CheckboxRadix from "@radix-ui/react-checkbox";
import { Row } from "../Row";
import Balancer from "react-wrap-balancer";
import "./Checkbox.scss";
import clsx from "clsx";

type CheckboxProps = {
  id: string;
  label?: React.ReactNode;
  checked: boolean;
  onChange: (checked: boolean) => void;
  classNameText?: string;
};

export const Checkbox = ({
  id,
  label,
  checked,
  onChange,
  classNameText = "fs-6 fw-bold",
}: CheckboxProps) => {
  const CheckIcon = () => (
    <svg
      width="14"
      height="14"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M10 3L4.5 8.5L2 6"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  const parser = new DOMParser();
  const html = parser.parseFromString(`${label}`, "text/html");
  const labelText = html?.body?.textContent || "";

  return (
    <Row alignItems="center" gap="x16">
      <CheckboxRadix.Root
        id={id}
        checked={checked}
        onCheckedChange={onChange}
        className={"ui-checkbox"}
        aria-label={labelText}
      >
        <CheckboxRadix.Indicator>
          <CheckIcon />
        </CheckboxRadix.Indicator>
      </CheckboxRadix.Root>
      {label && (
        <Balancer
          as="label"
          htmlFor={id}
          className={clsx(classNameText, "text-slate-20")}
        >
          {label}
        </Balancer>
      )}
    </Row>
  );
};
